import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { BaseIcon } from '../../../components/base-icon.mjs';

const SvgLaptopFile = forwardRef((props, ref) => /* @__PURE__ */ jsxs(BaseIcon, { fill: "currentColor", ref, ...props, children: [
  /* @__PURE__ */ jsx("path", { d: "M4 5.786C4 4.809 4.786 4 5.778 4h12.444C19.214 4 20 4.81 20 5.786v1.34A4 4 0 0 0 19 7h-3.566a4 4 0 0 0-2.922 1.268l-2.434 2.603A4 4 0 0 0 9 13.603V19q.002.519.126 1H4a2 2 0 0 1-2-2v-1a2 2 0 0 1 2-2z" }),
  /* @__PURE__ */ jsx("path", { d: "M15 9.048V13h-3.907a2 2 0 0 1 .446-.763l2.434-2.603A2 2 0 0 1 15 9.048" }),
  /* @__PURE__ */ jsx("path", { d: "M17 9v4a2 2 0 0 1-2 2h-4v4a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2z" })
] }));

export { SvgLaptopFile as default };
//# sourceMappingURL=laptop-file.mjs.map
